import React, { useState, useEffect } from 'react';
import { useAuth } from '../common/AuthProvider';
import { Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Alert} from 'react-bootstrap';
import { useSubscription } from '../common/SubscriptionsProvider';
import { fetchData } from '../common/Api';
import '../styles.css';
import UserSubscription from './UserSubscription';
import PlanCard from './PlanCard';
import PopupScroll from '../common/PopupScroll';


const SubscriptionsPage = () => {

    const [error, setError] = useState(null);
    const [errorPlans, setErrorPlans] = useState(null);
    const [isYearly, setIsYearly] = useState(false);
    const [subscriptions, setSubscriptions] = useState(null);
    const history = useHistory();
    const { isAuthenticated} = useAuth();
    const { activePlan, 
        getCurrentSubscription,
        handleCreateSubscription, 
        handleUpgradeFreeToBasic, 
        setToInitialState
    } = useSubscription();

    useEffect(() => {  
        if (!isAuthenticated){
            setToInitialState();
        }
        if (activePlan.plan === null && isAuthenticated) {
            const fetchCurrentSubscriiption = async () => {
                await getCurrentSubscription();
            }
                fetchCurrentSubscriiption();
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (activePlan.canceled){
            const diff = Math.floor((new Date(activePlan.end_date) - 
                new Date(activePlan.start_date)) / (1000 * 60 * 60 * 24 * 30));
            diff === 12 ? setIsYearly(true) : setIsYearly(false);
        } else if (activePlan.yearly === true){
            setIsYearly(true);
        } else {
            setIsYearly(false);
        }
    }, [activePlan]);

    useEffect(() => {
        const fetchSubscriptions = async () => {
          try {
            const response = await fetchData(`/api/v1/subscription/plans`);
            setSubscriptions(response.data);  
          } catch (error) {
            console.log("error occurred while fetching plans", error);
          };
        };
    
        fetchSubscriptions();
  
    }, []);

    const handleSubscription = (selectedPlan, payment) => {
        if (!isAuthenticated) {
            alert('You need to sign-up first');
            history.push('/sign-up');
        } else {
            if (activePlan.plan === null || activePlan.plan === undefined) {
                    handleCreateSubscription(selectedPlan, isYearly);
            } else {
                if (activePlan.plan === selectedPlan.name){
                    alert('You are already subscribed to this plan');
                } else if (activePlan.plan !== 'Free'){
                    selectedPlan.name === 'Free' 
                        ? alert('You cannot downgrade your subscription')
                        : handleUpgradeFreeToBasic(selectedPlan, isYearly);
                } else {
                    handleUpgradeFreeToBasic(selectedPlan, isYearly);
                }
            }
        }
    };

    useEffect(() => {
        setError('');
        setErrorPlans('');
    }, [isYearly]);

    const colors = ['#68AB88', '#72A1E5'];

    return (
        <div className='page-container'>
        <PopupScroll>
        <h1 className='sub-h'>Choose the subscription that is right for you. </h1>
        <h5 className='sub-h'>Cancel anytime you want.</h5>
        </PopupScroll>
        <div className='flex-row-center'>
            <div className='card-custom-container'>
            {
            subscriptions && subscriptions.map((subscription, index) => 
                
                <PopupScroll>
                    <PlanCard 
                    plan={subscription} 
                    activePlan={activePlan}
                    cardColor={colors[index]}
                    isYearly={isYearly}
                    handleSubscription={handleSubscription}
                    key={index}
                />
                </PopupScroll>
            )
            }
            </div>
        </div>
        {
            isAuthenticated && 
            <PopupScroll>
            <div className='flex-row-center text-container-div-max-width'>
                <UserSubscription />
            </div>
            </PopupScroll>
        }
                <PopupScroll>
        {/* <div className='flex-row-center'>
        {(activePlan.plan === null || activePlan.plan === undefined || activePlan.plan === 'Free') && 
            <Form onChange={() => setIsYearly(!isYearly)}>
            <Form.Check 
                type="switch"
                id="custom-switch"
                label="Show yearly subscription"
            />
            </Form>}
        </div> */}
        </PopupScroll>
        {error && <Alert variant="danger">{error}</Alert>}
        {errorPlans && <Alert variant="danger">{errorPlans}</Alert>}
        </div>
    );
};

export default SubscriptionsPage;
